module.exports = __webpack_public_path__ + "static/media/mpl-footer.cb83cf6f.png";